module.exports = {
  contentfulToInternal(entry) {
    const result = {
      id: entry.sys.id,
      createdAt: entry.sys.createdAt,
      updatedAt: entry.sys.updatedAt,
      visibility: entry.sys.visibility,
      name: entry.name
    };

    return result;
  }
};
